module.exports = __webpack_public_path__ + "static/tony-004-0c40fbba19902f678d33fc39b6fff477.jpg";